import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

export default (TYPE) => (lenderName) =>
    createAction(TYPE, createRequestPayload('media', `/content/resolve/lender_details/${lenderName}.json`));
